import { BusinessAccountFeature } from "../models/BusinessAccountFeature.model";

let BusinessDetails: BusinessAccountFeature = {
  features: [
    {
      id: 1,
      text: "Minimum account opening balance of =N=10,000 (For Legal Search)",
    },
    // {
    //   id: 2,
    //   text: "Access to overdraft facility.",
    // },
    // {
    //   id: 3,
    //   text: "AMF at =N=1/mille (Negotiable with huge turnover).",
    // },
    // {
    //   id: 4,
    //   text: "Access to business finance.",
    // },
    {
      id: 5,
      text: "Internet and mobile banking facility i.e., online statement, SMS alert etc.",
    },
    {
      id: 6,
      text: "Chequebook.",
    },
    {
      id: 7,
      text: "International funds transfer allowed.",
    },
  ],
  requirements: [
    {
      id: 1,
      text: "Certificate of Registration",
    },
    {
      id: 2,
      text: "Business email address",
    },
    {
      id: 3,
      text: "Taxpayer identification number TIN.",
    },
    {
      id: 4,
      text: "Partnership Deed (where applicable).",
    },
    {
      id: 5,
      text: "Basic information about business (business name, business address, business email and phone number, Registration number).",
    },
    {
      id: 6,
      text: "BVN of each signatory.",
    },
    {
      id: 7,
      text: "Valid and acceptable means of Identification for each signatory.",
    },
    {
      id: 8,
      text: "Basic information of each signatory/proprietor. (i.e., Name, Place and date of birth, Gender, Address, Telephone number)",
    },
    {
      id: 9,
      text: "References"
    },
    // {
    //   id: 9,
    //   text: "Two satisfactory corporate references.",
    // },
    // {
    //   id: 10,
    //   text: "One recent passport photograph of each signatory.",
    // },
    // {
    //   id: 11,
    //   text: "Power of attorney duly executed (where applicable) by the registered business owner where the signatory is different from the listed proprietor.",
    // },
    // {
    //   id: 12,
    //   text: "For professional bodies, evidence of duly registered membership of the professional body is required.",
    // },
    // {
    //   id: 13,
    //   text: "CERPAC- Combined Expatriate Residence Permit and Alien Card for directors of the company and signatories to the account who are foreign nationals.",
    // },
    // {
    //   id: 14,
    //   text: "SCUML Certificate (where applicable).",
    // },
  ],
};

let CompanyDetails: BusinessAccountFeature = {
  features: [
    {
      id: 1,
      text: "Minimum account opening balance of =N=10,000 (For Legal Search)",
    },
    // {
    //   id: 2,
    //   text: "Access to overdraft facility.",
    // },
    // {
    //   id: 3,
    //   text: "AMF at =N=1/mille (Negotiable with huge turnover).",
    // },
    // {
    //   id: 4,
    //   text: "Access to business finance.",
    // },
    {
      id: 5,
      text: "Internet and mobile banking facility i.e., online statement, SMS alert etc.",
    },
    {
      id: 6,
      text: "Chequebook.",
    },
    {
      id: 7,
      text: "International funds transfer allowed.",
    },
  ],
  requirements: [
    {
      id: 1,
      text: "Certificate of incorporation."
    },
    {
      id: 2,
      text: "Certified true copy of Form CO2 and CO7 or Form CAC 1.1"
    },
    {
      id: 3,
      text: "Certified true copy of Memorandum and Articles of Association."
    },
    {
      id: 4,
      text: "Taxpayer identification number TIN."
    },
    {
      id: 5,
      text: "Basic information about Company (company name, company address, company email and phone number, Registration number)."
    },
    {
      id: 6,
      text: "BVN of each signatory."
    },
    {
      id: 7,
      text: "Valid and acceptable means of Identification for each signatory."
    },
    {
      id: 8,
      text: "Basic information of each signatory/director. (i.e., Name, Place and date of birth, Gender, Address, Telephone number)."
    },
    {
      id: 9,
      text: "Board Resolution duly sealed and signed by two directors or a director and Secretary on company ,letter head."
    },
    {
      id: 10,
      text: "Two satisfactory corporate references."
    },
    {
      id: 11,
      text: "One recent passport photograph of each signatory."
    },
    {
      id: 12,
      text: "SCUML Certificate (where applicable)."
    },
    {
      id: 13,
      text: "For professional bodies, evidence of duly registered membership of the professional body is required."
    },
    {
      id: 14,
      text: "CERPAC- Combined Expatriate Residence Permit and Alien Card for directors of the company and signatories to the account who are foreign nationals."
    },
    // {
    //   id: 1,
    //   text: "Basic customer information (i.e., Name, Place, and date of Birth, Gender, Address, Telephone Number) **Address would be verified.",
    // },
    // {
    //   id: 2,
    //   text: "BVN",
    // },
    // {
    //   id: 3,
    //   text: "Passport Photograph",
    // },
    // {
    //   id: 4,
    //   text: "Signature",
    // },
    // {
    //   id: 5,
    //   text: "Valid ID",
    // },
    // {
    //   id: 6,
    //   text: "2 Suitable references",
    // },
    // {
    //   id: 9,
    //   text: "References"
    // },
  ],
};

export const features = {
  BusinessDetails,
  CompanyDetails,
};
